import * as cookieServices from '../services/cookies/cookieServices';

 export function getCalAmpBaseUri(){

    /*
      non posso salvare semplicemente l'id nel cookie perchè da qui il settings da cui
      posso leggere la lista di application non è disponibile
      quindi salvo direttamente tutte le info di cui necessito nel cookie
    */
    var appData = cookieServices.getAppCookie();
    if(!appData) {
      console.error("cookieServices returns null appData");
      return null;
    }

    return appData.baseUri;
  }

  export function getCalAmpAppKey(){
    /*
      non posso salvare semplicemente l'id nel cookie perchè da qui il settings da cui
      posso leggere la lista di application non è disponibile
      quindi salvo direttamente tutte le info di cui necessito nel cookie
    */

    var appData = cookieServices.getAppCookie();
    if(!appData) {
      console.error("cookieServices returns null appData");
      return null;
    }

    return appData.key;
  }

  export function getJasperConnect(){
    /*
      non posso salvare semplicemente l'id nel cookie perchè da qui il settings da cui
      posso leggere la lista di application non è disponibile
      quindi salvo direttamente tutte le info di cui necessito nel cookie
    */

    var appData = cookieServices.getAppCookie();
    if(!appData) {
      console.error("cookieServices returns null appData");
      return null;
    }

    return appData.jasperConnect;
  }

  export function getJasperSessionId(){
    /*
      non posso salvare semplicemente l'id nel cookie perchè da qui il settings da cui
      posso leggere la lista di application non è disponibile
      quindi salvo direttamente tutte le info di cui necessito nel cookie
    */

    var appData = cookieServices.getJasperSessionId();
    if(!appData) {
      console.error("cookieServices returns null appData");
      return null;
    }

    return appData;
  }


// WEBPACK FOOTER //
// ./src/settings/globalVars.js